import React, { FC } from 'react';
import styles from './TableOptions.module.scss';
import { SimpleColumn } from './types';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import classNames from 'classnames';
import { Checkbox } from 'antd';
import { motion } from 'framer-motion';
import { fadein, item } from '../../Shared/Motion';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

type Props = {
  anyHidden: boolean;
  toShowColumns: string[];
  hiddenColumns: SimpleColumn[];
  toShowColumnsSelected: (checkedValues: CheckboxValueType[]) => void;
};

const HiddenColumns: FC<Props> = ({ anyHidden, hiddenColumns, toShowColumns, toShowColumnsSelected }) => {
  const selectAll = (e: CheckboxChangeEvent) => {
    if (e.target.checked) {
      const all = hiddenColumns.map(x => x.key);
      toShowColumnsSelected(all);
    } else {
      toShowColumnsSelected([]);
    }
  };

  return (
    <motion.div initial='hidden' animate='visible' variants={fadein}>
      <h5 className={styles.columnTitle}>Hidden Columns</h5>
      <motion.div className={styles.columnsActions}>
        <Checkbox onChange={selectAll} checked={toShowColumns.length === hiddenColumns.length}>
          Select All
        </Checkbox>
      </motion.div>
      <motion.div
        className={classNames(styles.columnsBox, {
          [styles.emptyBox]: !anyHidden
        })}
      >
        {!anyHidden && <span>Nothing is hidden</span>}
        {anyHidden && (
          <Checkbox.Group value={toShowColumns} style={{ width: '100%' }} onChange={toShowColumnsSelected}>
            {hiddenColumns.map((column: SimpleColumn) => (
              <motion.div key={column.key} variants={item} className={styles.orderableCard}>
                <Checkbox value={column.key}>{column.title}</Checkbox>
              </motion.div>
            ))}
          </Checkbox.Group>
        )}
      </motion.div>
    </motion.div>
  );
};

export default HiddenColumns;
